// What the Analyser keeps of an account's datalogs in this browser goes when the owner signs out: the parsed logs
// (data/logCache.ts) and the circuits it found (site/lib/datalogCircuitCache.ts).
import { LOG_CACHE_DB } from './data/logCache';
import { forgetDatalogCircuits } from './site/lib/datalogCircuitCache';

export function forgetAnalysedLogs(): void {
  try {
    indexedDB.deleteDatabase(LOG_CACHE_DB);
  } catch {
    // No IndexedDB: nothing was kept.
  }
  forgetDatalogCircuits();
}
